import { Injectable } from '@angular/core';
import { Size } from '../data-models/common.interfaces';

@Injectable({ providedIn: 'root' })
export class WindowUtilsService {
  /**
   * Get browser area/size
   */
  getBrowserArea(): Size {
    let width = 0;
    let height = 0;

    const w = window;

    if (typeof w.innerWidth === 'number') {
      // Non-IE
      width = w.innerWidth;
      height = w.innerHeight;
    } else {
      //  IE 6+ followed by IE 4
      width =
        w.document?.documentElement?.clientWidth ??
        w.document?.body?.clientWidth;
      height =
        w.document?.documentElement?.clientHeight ??
        w.document?.body?.clientHeight;
    }
    return {
      width,
      height,
      label: `${width}x${height}`
    };
  }

  /** function for window.location */
  location(url: string) {
    window.location.href = url;
  }

  /**
   * Get screen resolution
   */
  getScreenResolution(): Size {
    const width = window.screen.width;
    const height = window.screen.height;

    return {
      width,
      height,
      label: `${width}x${height}`
    };
  }

  /**
   * Wrapper function for window.open
   */
  // Removed 4th parameter replace?:boolean
  open(url: string, target?: string, features?: string) {
    window.open(url, target, features);
  }

  print() {
    window.print();
  }
}
